// extracted by mini-css-extract-plugin
export default {"modal_header":"LearnMoreModal_modal_header__MbcD9","modal_background":"LearnMoreModal_modal_background__Y4X+R"};